import React, { useEffect, useState } from 'react';
import { isDev } from '../../utils/Env';
import { useAuth } from '../auth/AuthProvider';

const allowedOrigin =
    isDev || window.location.host === 'accounts-d.bikiran.com'
        ? ['http://localhost:3000']
        : [
              'https://www.bikiran.com',
              'https://admins.bikiran.com',
              'https://push.bikiran.com',
              'https://console.bikiran.com'
          ];

function CrossPage() {
    const { authInfo, signOut } = useAuth();
    const [receivedDate, setReceivedData] = useState({ data: null, origin: '' });

    // --Send  Ready Message
    useEffect(() => {
        window?.parent?.postMessage({ action: 'ready' }, '*');
    }, []);

    useEffect(() => {
        // --Sent Login Info
        if (
            authInfo.loading === false &&
            receivedDate.action === 'login-required' &&
            allowedOrigin.find((item) => item === receivedDate.origin)
        ) {
            window?.parent?.postMessage({ ...authInfo, action: 'login' }, receivedDate.origin);
        }
    }, [authInfo, receivedDate]);

    useEffect(() => {
        // --Sent Logout Info
        if (
            authInfo.loading === false &&
            receivedDate.action === 'logout-required' &&
            allowedOrigin.find((item) => item === receivedDate.origin)
        ) {
            signOut()
                .then((data) => {
                    window?.parent?.postMessage({ ...data, action: 'logout' }, receivedDate.origin);
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }, [authInfo, receivedDate, signOut]);

    useEffect(() => {
        const handelMessageListener = ({ data, origin }) => {
            console.log(data, origin);
            setReceivedData({ ...data, origin });
        };

        window.addEventListener('message', handelMessageListener);

        return () => {
            window.removeEventListener('message', handelMessageListener);
        };
    }, []);

    return <div>CrossPage</div>;
}

export default CrossPage;
